import './preferences.scss';
import { useTranslation } from 'react-i18next';
import { CgChevronRight } from 'react-icons/cg';
import { useState } from 'react';
import { BreadcrumbItem } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb.types';
import Subheader from '../../common/components/subheader';
import PreferencesConstants from './constants';
import HomeConstants from '../home/constants';
import General from './components/general';
import LoadsRounds from './components/loads-rounds';
import LoadsPool from './components/loads-pool';
import AuthContext from '../../app/contexts/auth';
import { SULAHUB_ROLES } from '../../common/constants/roles';

function Preferences() {
    const { t } = useTranslation();
    const { isAuthorized } = AuthContext.useAuth();

    const [generalOpened, setGeneralOpened] = useState<boolean>(false);
    const [loadsRoundsOpened, setLoadsRoundsOpened] = useState<boolean>(false);
    const [loadsPoolOpened, setLoadsPoolOpened] = useState<boolean>(false);

    const breadcrumbList: BreadcrumbItem[] = [
        { label: HomeConstants.PAGE_TITLE, url: HomeConstants.PATH },
        { label: t('Preferências'), url: PreferencesConstants.PATH },
    ];

    return (
        <>
            <Subheader
                title={t(PreferencesConstants.PAGE_TITLE)}
                breadcrumbList={breadcrumbList}
                data-testid="carrier-subheader"
            />

            <div className="preferences-container">
                <div className="preferences-list-container">
                    <div className="preferences-list">
                        <div>
                            <span>{t('General')}</span>
                            <button
                                type="button"
                                onClick={() => {
                                    setGeneralOpened(true);
                                    setLoadsRoundsOpened(false);
                                    setLoadsPoolOpened(false);
                                }}
                                data-testid="general-button"
                            >
                                <CgChevronRight />
                            </button>
                        </div>

                        {isAuthorized([
                            SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                            SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
                            SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                        ]) && (
                            <div>
                                <span>{t('LoadsRoundsManagement')}</span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setGeneralOpened(false);
                                        setLoadsRoundsOpened(true);
                                        setLoadsPoolOpened(false);
                                    }}
                                    data-testid="round-configuration-management-button"
                                >
                                    <CgChevronRight />
                                </button>
                            </div>
                        )}

                        {isAuthorized([
                            SULAHUB_ROLES.SYSTEM_PROFILES.SULA_USER,
                            SULAHUB_ROLES.SYSTEM_PROFILES.OPERATION_USER,
                            SULAHUB_ROLES.SYSTEM_PROFILES.MESA_PLUS_ADMIN,
                        ]) && (
                            <div>
                                <span>{t('LoadsPoolManagement')}</span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        setGeneralOpened(false);
                                        setLoadsRoundsOpened(false);
                                        setLoadsPoolOpened(true);
                                    }}
                                    data-testid="pool-configuration-management-button"
                                >
                                    <CgChevronRight />
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="selected-preference-options">
                    {generalOpened && <General />}

                    {loadsRoundsOpened && <LoadsRounds />}

                    {loadsPoolOpened && <LoadsPool />}
                </div>
            </div>
        </>
    );
}

export default Preferences;
